import { render, staticRenderFns } from "./ColorStock.vue?vue&type=template&id=c3fd1966&"
import script from "./ColorStock.vue?vue&type=script&lang=ts&"
export * from "./ColorStock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports